import { Endpoint } from '../endpoint';
import { FormId, CompactFormResponse, FormResponse } from '@business/entities/managementFormTemplate';

export function fetchForms() {
  return Endpoint.get<CompactFormResponse[]>(`@makh/management-form-template`);
}

export function fetchForm(id: FormId) {
  return Endpoint.get<FormResponse>(`@makh/management-form-template/form/${id}`);
}

export function createForm(data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@makh/management-form-template`, { data });
}

export function updateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.patch<FormResponse>(`@makh/management-form-template/${id}`, { data });
}

export function deleteForm(id: FormId) {
  return Endpoint.delete<void>(`@makh/management-form-template/${id}`);
}

export function duplicateForm(id: FormId, data: Partial<FormResponse>) {
  return Endpoint.post<FormResponse>(`@makh/management-form-template/duplicate/${id}`, { data });
}

export function saveFormFields(id: FormId, data: Pick<FormResponse, 'fields'>) {
  return Endpoint.post<FormResponse>(`@makh/management-form-template/save-fields/${id}`, { data });
}

export function deleteFormShare(id: string) {
  return Endpoint.delete<void>(`@makh/management-form-template/delete-share/${id}`);
}
